// Stimulus контроллер для переводимых форм
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["localeSelector"]
  static values = { currentLocale: String }

  connect() {
    this.form = this.element
    this.changed = false
    
    // Отслеживаем изменения в форме
    this.form.addEventListener("input", this.markAsChanged.bind(this))
    this.form.addEventListener("change", this.markAsChanged.bind(this))
    
    // Предупреждение при уходе со страницы
    // console.log("Подключение TranslatedFormController")
    this.beforeUnloadHandler = this.beforeUnload.bind(this)
    window.addEventListener("beforeunload", this.beforeUnloadHandler)
  }

  disconnect() {
    // console.log("Disconnecting TranslatedFormController")
    window.removeEventListener("beforeunload", this.beforeUnloadHandler)
  }

  markAsChanged(event) {
    if (event.target.name == "form_locale") return;
    // console.log("Форма изменена", event);
    this.changed = true
  }

  beforeUnload(event) {
    if (this.changed) {
      console.log("Покидаем страницу с несохранёнными изменениями")
      const message = "У вас есть несохранённые изменения. Вы уверены, что хотите покинуть страницу?"
      event.returnValue = message
      return message
    }
  }

  changeLocale(event) {
    const newFormLocale = event.target.value
    
    // Если форма изменена, показываем предупреждение
    if (this.changed) {
      const confirmMessage = "При смене языка формы несохранённые данные могут быть потеряны. Продолжить?"
      if (!confirm(confirmMessage)) {
        // Возвращаем предыдущий выбор
        event.target.value = this.currentLocaleValue
        event.preventDefault()
        return
      }
    }

    // Обновляем URL с новой локалью формы (не меняя общую локаль сайта)
    this.updateUrlWithFormLocale(newFormLocale)
  }

  updateUrlWithFormLocale(formLocale) {
    const url = new URL(window.location)
    
    // Устанавливаем параметр form_locale вместо locale
    url.searchParams.set("form_locale", formLocale)
    
    // Сохраняем остальные параметры (включая общий locale если есть)
    
    // Используем Turbo для плавной перезагрузки
    Turbo.visit(url.toString())
  }

  // Сброс флага изменений (используется после успешного сохранения)
  resetChanged() {
    this.changed = false
  }

  // Метод для программного изменения локали формы
  setFormLocale(locale) {
    if (this.hasLocaleSelector) {
      this.localeSelectorTarget.value = locale
      this.currentLocaleValue = locale
    }
  }
}
